export var MenuUrlTarget = new Map([[false, '_self'], [true, '_blank']]);
export var ETopBannerType;
(function (ETopBannerType) {
  ETopBannerType["promo"] = "promo";
  ETopBannerType["tech"] = "tech";
})(ETopBannerType || (ETopBannerType = {}));
export var EMetricAction;
(function (EMetricAction) {
  EMetricAction["view"] = "view";
  EMetricAction["click"] = "click";
  EMetricAction["fill_in"] = "fill_in";
})(EMetricAction || (EMetricAction = {}));
export var EMetricItemType;
(function (EMetricItemType) {
  EMetricItemType["element"] = "element";
  EMetricItemType["field"] = "field";
  EMetricItemType["notification"] = "notification";
  EMetricItemType["popup"] = "popup";
  EMetricItemType["banner"] = "banner";
  EMetricItemType["button"] = "button";
  EMetricItemType["block"] = "block";
})(EMetricItemType || (EMetricItemType = {}));
export var EMetricBlockName;
(function (EMetricBlockName) {
  EMetricBlockName["keywords"] = "keywords";
  EMetricBlockName["recommendations"] = "recommendations";
})(EMetricBlockName || (EMetricBlockName = {}));